import React from "react";

import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

import {
  formatActivityHistoryDateTime,
  getActivityHistoryItems,
} from "./submissionTableUtils";

import "./ActivityHistoryModal.css";

export default function ActivityHistoryModal({
  open,
  submission,
  onClose,
}) {
  const activityItems = getActivityHistoryItems(submission);
  const sampleLabel = submission?.submit_name || submission?.submit_id || "";

  return (
    <Modal
      title=""
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={480}
      wrapClassName="ActivityHistoryModal"
      closeIcon={<CloseOutlined />}
    >
      <div className="ActivityHistoryModal__Header">
        <h3 className="ActivityHistoryModal__Title">Submission Activity History</h3>
        <p className="ActivityHistoryModal__Subtitle" title={sampleLabel}>
          {`Submission Name: ${sampleLabel}`}
        </p>
      </div>

      <div className="ActivityHistoryModal__Body">
        {activityItems.length === 0 ? (
          <p className="ActivityHistoryModal__Empty">No submission activity history available.</p>
        ) : (
          <ul className="ActivityHistoryModal__Timeline">
            {activityItems.map((item, index) => (
              <li key={`${item.title}-${item.date}-${index}`} className="ActivityHistoryModal__TimelineItem">
                <div className="ActivityHistoryModal__Card">
                  <span className="ActivityHistoryModal__TimelineMarker" aria-hidden>
                    <CheckOutlined />
                  </span>
                  <span className="ActivityHistoryModal__CardContent">
                    <p className="ActivityHistoryModal__CardTitle">{item.title}</p>
                    <p className="ActivityHistoryModal__CardMeta">
                      {item.user}
                      {item.date ? ` • ${formatActivityHistoryDateTime(item.date)}` : ""}
                    </p>
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="ActivityHistoryModal__Footer">
        <Button type="default" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  );
}
